__turbopack_context__.v({
  "amount": "instant-sell-module__0EsWPq__amount",
  "back": "instant-sell-module__0EsWPq__back",
  "belowFloorPercent": "instant-sell-module__0EsWPq__belowFloorPercent",
  "bolt": "instant-sell-module__0EsWPq__bolt",
  "card": "instant-sell-module__0EsWPq__card",
  "compact": "instant-sell-module__0EsWPq__compact",
  "connect": "instant-sell-module__0EsWPq__connect",
  "dropdownItems": "instant-sell-module__0EsWPq__dropdownItems",
  "dropdownPanel": "instant-sell-module__0EsWPq__dropdownPanel",
  "dropdownTrigger": "instant-sell-module__0EsWPq__dropdownTrigger",
  "empty": "instant-sell-module__0EsWPq__empty",
  "floorPill": "instant-sell-module__0EsWPq__floorPill",
  "floorPillDanger": "instant-sell-module__0EsWPq__floorPillDanger",
  "headerTabs": "instant-sell-module__0EsWPq__headerTabs",
  "inlineDropdown": "instant-sell-module__0EsWPq__inlineDropdown",
  "inlinePicker": "instant-sell-module__0EsWPq__inlinePicker",
  "item": "instant-sell-module__0EsWPq__item",
  "itemDropdown": "instant-sell-module__0EsWPq__itemDropdown",
  "itemSearch": "instant-sell-module__0EsWPq__itemSearch",
  "itemSearchRow": "instant-sell-module__0EsWPq__itemSearchRow",
  "itemSort": "instant-sell-module__0EsWPq__itemSort",
  "items": "instant-sell-module__0EsWPq__items",
  "offer": "instant-sell-module__0EsWPq__offer",
  "offerCopy": "instant-sell-module__0EsWPq__offerCopy",
  "offerGroup": "instant-sell-module__0EsWPq__offerGroup",
  "offerListEntry": "instant-sell-module__0EsWPq__offerListEntry",
  "offers": "instant-sell-module__0EsWPq__offers",
  "pickerHint": "instant-sell-module__0EsWPq__pickerHint",
  "price": "instant-sell-module__0EsWPq__price",
  "priceAmounts": "instant-sell-module__0EsWPq__priceAmounts",
  "priceBolt": "instant-sell-module__0EsWPq__priceBolt",
  "priceCaption": "instant-sell-module__0EsWPq__priceCaption",
  "priceCard": "instant-sell-module__0EsWPq__priceCard",
  "priceFigure": "instant-sell-module__0EsWPq__priceFigure",
  "priceIdentity": "instant-sell-module__0EsWPq__priceIdentity",
  "primary": "instant-sell-module__0EsWPq__primary",
  "selectedOffer": "instant-sell-module__0EsWPq__selectedOffer",
  "selectedSaleItem": "instant-sell-module__0EsWPq__selectedSaleItem",
  "sort": "instant-sell-module__0EsWPq__sort",
  "subheading": "instant-sell-module__0EsWPq__subheading",
  "tabs": "instant-sell-module__0EsWPq__tabs",
  "thumbnail": "instant-sell-module__0EsWPq__thumbnail",
  "topLabel": "instant-sell-module__0EsWPq__topLabel",
  "viewAll": "instant-sell-module__0EsWPq__viewAll",
});
